import { useParams, Link } from 'react-router-dom';
import { useMemo } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SchemaOrg from '@/components/feature/SchemaOrg';
import ArticleContent from './components/ArticleContent';
import RelatedArticles from './components/RelatedArticles';
import { articles, categories } from '@/mocks/articles';

export default function ArticlePage() {
  const { id } = useParams<{ id: string }>();

  const article = useMemo(() => articles.find((a) => a.id === id), [id]);

  if (!article) {
    return (
      <>
        <ScrollToTop />
        <div className="min-h-screen bg-background-50">
          <Navbar />
          <main className="pt-24 md:pt-28 pb-14">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <div className="flex flex-col items-center justify-center py-20 text-foreground-400">
                <i className="ri-file-unknow-line text-5xl mb-4"></i>
                <p className="text-lg">文章不存在或已被删除</p>
                <Link to="/" className="mt-4 text-primary-500 hover:text-primary-600 text-sm">
                  返回首页
                </Link>
              </div>
            </div>
          </main>
          <Footer />
        </div>
      </>
    );
  }

  const catInfo = categories.find((c) => c.id === article.category);

  return (
    <>
      <ScrollToTop />
      <SchemaOrg
        type="Article"
        data={{
          headline: article.title,
          description: article.excerpt,
          datePublished: article.date,
          author: {
            '@type': 'Person',
            name: article.author,
          },
          publisher: {
            '@type': 'Organization',
            name: '黑料社区',
          },
          image: article.image,
          url: `https://heiliao.community/article/${article.id}`,
          mainEntityOfPage: {
            '@type': 'WebPage',
            '@id': `https://heiliao.community/article/${article.id}`,
          },
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-24 md:pt-28 pb-14">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="mb-6">
              <Breadcrumb
                items={[
                  { label: '首页', href: '/' },
                  { label: catInfo?.name || '分类', href: `/category/${article.category}` },
                  { label: article.title.length > 20 ? article.title.slice(0, 20) + '...' : article.title },
                ]}
              />
            </div>

            <ArticleContent
              title={article.title}
              author={article.author}
              date={article.date}
              category={article.category}
              views={article.views}
              comments={article.comments}
              content={article.content}
              tags={article.tags}
            />
          </div>

          <RelatedArticles currentId={article.id} category={article.category} />
        </main>

        <Footer />
      </div>
    </>
  );
}